const cookies = {
  swapPlanOfferSeen: 'swap_plan_offer_seen',
  hasSeenPuppyFlow: 'has_seen_puppy_flow',
  restartBoxSelectedDate: 'restart_box_selected_date',
  swapToMFITBPlanOfferSeen: 'swap_to_mfitb_plan_offer_seen',
  reviewingMFITBPlanOffer: 'reviewing_mfitb_plan_offer',
  showDiscountBannerOnStaticPages: 'show_discount_banner_on_static_pages'
}

export default cookies
